import { render, staticRenderFns } from "./Push.vue?vue&type=template&id=1f660cce&scoped=true&"
import script from "./Push.vue?vue&type=script&lang=js&"
export * from "./Push.vue?vue&type=script&lang=js&"
import style0 from "./Push.vue?vue&type=style&index=0&id=1f660cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f660cce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f660cce')) {
      api.createRecord('1f660cce', component.options)
    } else {
      api.reload('1f660cce', component.options)
    }
    module.hot.accept("./Push.vue?vue&type=template&id=1f660cce&scoped=true&", function () {
      api.rerender('1f660cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Customers/Push.vue"
export default component.exports